/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Card_HeadingInputs */

const en_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to Glider`)
};

const de_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Glider anmelden`)
};

const pt_br2_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar na Glider`)
};

const tr_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider'a giriş yapın`)
};

const zh_cn2_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录 Glider`)
};

const zh_hk2_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入 Glider`)
};

const ko_kr2_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider에 로그인`)
};

const ru_ru2_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти в Glider`)
};

const es_419_login_page_card_heading = /** @type {(inputs: Login_Page_Card_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión en Glider`)
};

/**
* | output |
* | --- |
* | "Sign in to Glider" |
*
* @param {Login_Page_Card_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_card_heading = /** @type {((inputs?: Login_Page_Card_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Card_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_card_heading(inputs)
	if (locale === "de") return de_login_page_card_heading(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_card_heading(inputs)
	if (locale === "tr") return tr_login_page_card_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_card_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_card_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_card_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_card_heading(inputs)
	return es_419_login_page_card_heading(inputs)
});